export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">Sugargoo Sheet</span>
            </div>
            <p className="text-xs leading-relaxed text-background-50/50 mb-4">
              The ultimate independent resource hub for Sugargoo spreadsheet products. We help shoppers discover, compare, and purchase with confidence.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer text-background-50/60">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer text-background-50/60">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer text-background-50/60">
                <i className="ri-reddit-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#categories" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Categories</a>
              <a href="#what-is" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">About Sugargoo Spreadsheet</a>
              <a href="#resources" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Resource Center</a>
              <a href="#articles" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Guides &amp; Articles</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Sugargoo Spreadsheet</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Buy It Now</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Shopping Guide</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Legal</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-xs text-background-50/50">Privacy Policy</span>
              <span className="text-xs text-background-50/50">Terms of Service</span>
              <span className="text-xs text-background-50/50">Disclaimer</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} Sugargoo Sheet. All rights reserved. This is an independent resource website and is not affiliated with or endorsed by Sugargoo.
            </p>
            <p className="text-xs text-background-50/30">
              Independent Resource &middot; Not Official Sugargoo
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}